var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.featuresText[_vm.value]
    ? _c(
        "div",
        {
          directives: [
            {
              name: "tippy",
              rawName: "v-tippy",
              value: { followCursor: true, placement: "bottom-end" },
              expression: "{ followCursor: true, placement: 'bottom-end' }",
            },
          ],
          class: { "plans-feature": true },
          attrs: {
            content: _vm.featuresText[_vm.value](_vm.features[_vm.value]),
          },
        },
        [
          _c(
            "div",
            { staticClass: "plans-feature-text" },
            [
              _c("FeatureIcon"),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.featuresText[_vm.value](_vm.features[_vm.value]))
                ),
              ]),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }